import "bootstrap/dist/css/bootstrap.min.css";
import React, { Component, useEffect, useState } from "react";
import useStateRef from "react-usestateref";
import { Card, Row, Col, Container, Dropdown, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios from "axios";
import "./HeaderMaster.css";
// dashboard css atsrt
// dashboard css end
// mui css import start
import { MenuItem, DialogContent, Dialog } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
// mui css import end
// images start
import Logo from '../../assets/Doctor_Images/Avelator_Logo.png'
// import Notification from '../../assets/Doctor_web_Icon/Group 19086.svg'
import support from '../../assets/Doctor_web_Icon/male-telemarketer.svg'
import Notification from '../../assets/Doctor_Images/notification (1).png'
import emptyNotification from '../../assets/Doctor_Images/notification (1).png'
// import videoIcon from '../../assets/Doctor_web_Icon/Group21005.svg'


// images end
// component imnporting start
import Service from '../../helpers/Service'
import DashboardMasterComponent from "../Dashboard/DashboardMaster";
import FooterMaster from '../Dashboard/FooterMaster'
// component imnporting end
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Grid from '@mui/material/Grid';
import Postimg from '../../assets/clinicIcon/homePageIcon/post.svg';
import Manageserviceimg from '../../assets/clinicIcon/homePageIcon/manageService.svg';
import Supportimg from '../../assets/Doctor_web_Icon/Group 21105.png';
import Workinghoursimg from '../../assets/clinicIcon/homePageIcon/workhours.svg';
// import CollateralPlayIcon from '../../assets/Doctor_web_Icon/Group21005.svg';
import closeicon from '../../assets/icon/Icon ionic-ios-close.png';
import handIcon from '../../assets/Doctor_web_Icon/Path 38456.svg';
import homeIcon from '../../assets/Doctor_web_Icon/Group 9.png';
import RejectIcon from "../../images/rejectIcon.svg"
import editIcon from "../../assets/Doctor_web_Icon/edit.svg"
import logoutIcon from "../../assets/Doctor_web_Icon/Group 23875.svg";
import { decryptAESKey,setupKeys,encryptData, decryptData } from '../Crypto_Helpers/cryptoHelper';
import { initEncryptionSession } from '../../encryptionSession';
import Cookies from "js-cookie";


const HeaderMasterComponent = ({ onEdit }) => {
    // Navigation 
    let Var_History = useHistory();
    // Navigation 
    // Route Navigation start
    const routeNavigation = (path) => { Var_History.push("/dashboard" + path) };
    const routeNavigationByVerification = (path) => {
        Var_History.push({
            pathname: "/dashboard" + path, state: {  // location state
                verification: true,
            }
        })
    };
    // Route Navigation end
    // variable declaration start
    const [Var_Profiledata, setVar_Profiledata, Var_Profiledata_ref] = useStateRef([]);
    const [Var_getClinicWiseDoctor, setVar_getClinicWiseDoctor, Var_getClinicWiseDoctor_Ref] = useStateRef([]);
    const [Var_doctorSpecialitySelect, setVar_doctorSpecialitySelect, Var_doctorSpecialitySelect_Ref] = useStateRef(null);
    const [Var_PermissionObject, setVar_PermissionObject, Var_PermissionObject_Ref] = useStateRef([]);
    const [loading, setLoading] = useState(true);
    const [verificationPage, setVerificationPage] = useState(false);
    const [Var_NotificationData, setVar_NotificationData] = React.useState([]);
    const [Varnotificationcount, setVarnotificationcount, Varnotificationcount_Ref] = useStateRef([]);
    var [activeStep, setActiveStep] = useState(0);
    var [stepList, setStepList] = useState([
        { "label": "Reviewed & Approved", "dateTime": "23-Jun-23 10:00AM" },
        { "label": "Reviewed & Approved", "dateTime": "24-Jun-23 11:00AM" },
        { "label": "Reviewed & Approved", "dateTime": "25-Jun-23 12:00PM" },
        { "label": "You are ready", "dateTime": "to go live" }]);
    var [isOpenVideoPopup, setisOpenVideoPopup] = useState(false);
    var [videoPopupTitle, setVideoPopupTitle] = useState("");
    var [videoListbyMenu, setVideoListbyMenu] = useState([]);
    var [menuVideo, setMenuVideo] = useState([]);
    var [currentVideo, setCurrentVideo] = useState("");
    var [currentSubmenuid, setCurrentSubmenuid] = useState("");
    var [Var_DoctorId, setVar_DoctorId] = useState("");
    var [approved, setApproved] = useState("P");
    var [approvedLive, setApprovedLive] = useState("");
    var [approvedStatus, setApprovedStatus] = useState(0);
    var [declineStatus, setDeclinestatus] = useState("");
    const [ProfilePopupOpen, setProfilePopupOpen, ProfilePopupOpen_Ref] = useStateRef(false);
    var [headerDropdownStatus, setheaderDropdownStatus, headerDropdownStatus_Ref] = useStateRef(false);
    const [Var_ProfileSuccessfully, setVar_ProfileSuccessfully] = useStateRef("");
    const [Var_IsShowSuccess, setVar_IsShowSuccess] = React.useState(false);
    const [Var_DoctorClinicSelect, setVar_DoctorClinicSelect, Var_DoctorClinicSelect_Ref] = useStateRef([]);
    const [Var_DoctorCurrentClinic, setVar_DoctorCurrentClinic, Var_DoctorCurrentClinic_Ref] = useStateRef(null);
    const [VarSpeciality, setVarSpeciality,VarSpeciality_Ref] = useStateRef(null);

    // variable declaration end
    // Initial load method start
    useEffect(() => {
        // getClinicWiseDoctor();
        getClinicDoctor();
        var location = window.location.href.slice(-10);
        console.log(location, "123457890");
        if (location == '/dashboard' || location == 'dashboard/') {
            setheaderDropdownStatus(true);
        } else {
            setheaderDropdownStatus(false);
        }
        getDoctorProfile();
        getMenulist();
        Cookies.set("Collaterals_Page", false, { expires: 1 });
        // localStorage.setItem("Collaterals_Page", false);
        // getNotifications();
        // clinicTabPermissionById();
    }, []);
    // Initial load method end
    // get doctor profile api call start
    async function getDoctorProfile() {
        const aesKey = await initEncryptionSession();
        setLoading(true);
        var data = {
            doctorId: Cookies.get("Doctor_id")
        };
        const encrypted = await encryptData(data, aesKey);

        axios
            .post("doctor/getDoctorDetails", {
          objects:encrypted
        }
            )
            .then(async (response) => {
                const decryptedData = await decryptData(
                                                    response.data.data,        // encrypted data only
                                                    aesKey
                                                  );
                                                response.data.data = decryptedData;
                Cookies.set("speciality_Id", response.data.data[0].speciality[0].specialityId, { expires: 1 });                                
                // localStorage.setItem("speciality_Id", response.data.data[0].speciality[0].specialityId);
                setVar_Profiledata(response.data.data);
                // getClinicWiseDoctor();
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
            });
    }
    // get doctor profile api call end
    // get clinic wise doctor api call start
    function getClinicWiseDoctor() {
        setLoading(true);
        var data = {
            clinic_id: Cookies.get("Clinic_id")
        };
        axios
            .post("clinic/getClinicWiseDoctor", data)
            .then((response) => {
                if (response.data.data.length != 0) {
                    if (Cookies.get("clinic_doctor_name") === "Clinic_Doctor") {

    setVar_getClinicWiseDoctor(response.data.data);

    Cookies.set("Doctor_id", response.data.data[0].doctor_id, { expires: 1 });
    Cookies.set("doctor_Name", response.data.data[0].doctorName, { expires: 1 });
    Cookies.set("contract_status", response.data.data[0].contract_status, { expires: 1 });
    Cookies.set("speciality_Id", response.data.data[0].specialityid, { expires: 1 });

    setVar_doctorSpecialitySelect(response.data.data[0]);

    Service.doctorDetail = response.data.data[0];

    clinicTabPermissionById();
    checkThreeStepVerification(response.data.data[0].doctor_id);

    setLoading(false);

} else {

    if (Cookies.get("clinic_doctor_name") === "Clinic_Doctor_Change") {

        setVar_getClinicWiseDoctor(response.data.data);
        for (let i = 0; i < Var_getClinicWiseDoctor_Ref.current.length; i++) {

            if (
                Cookies.get("changes_doctor") == response.data.data[i].doctor_id &&
                Cookies.get("speciality_Id") == response.data.data[i].specialityid
            ) {

                setVar_doctorSpecialitySelect(response.data.data[i]);

                Service.doctorDetail = response.data.data[i];

                clinicTabPermissionById();
                checkThreeStepVerification(Cookies.get("Doctor_id"));

                setLoading(false);

                console.log(Cookies.get("Doctor_id"), "Doctor_Changes_1");
            }
        }
    }

    console.log(Cookies.get("Doctor_id"), "Doctor_Changes");

    setLoading(false);
}
                } else {
                    setApproved('P');
                    setVerificationPage(true);
                    setActiveStep(0);
                    // localStorage.setItem("contract_status", "null");
                }
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
            });
    }
    // get clinic wise doctor api call end
    // const doctorSpecialityId = (e) => {
    //     debugger;
    //     localStorage.setItem("clinic_doctor_name", "Clinic_Doctor_Change");
    //     localStorage.setItem("speciality_Id", e.target.value.specialityid);
    //     localStorage.setItem("doctor_id", e.target.value.doctor_id);
    //     localStorage.setItem("Doctor_id", e.target.value.doctor_id);
    //     localStorage.setItem("changes_doctor", e.target.value.doctor_id);
    //     localStorage.setItem("doctor_Name", e.target.value.doctorName);
    //     localStorage.setItem("contract_status", e.target.value.contract_status);
    //     setVar_doctorSpecialitySelect(e.target.value);
    //     clinicTabPermissionById();
    //     checkThreeStepVerification(e.target.value.doctor_id)
    //     sendToken();
    //     // Var_History.push("/dashboard/");
    // }
    const clinicTabPermissionById = () => {
        //setLoading(true);
        var data = {
            doctorId: Cookies.get("Doctor_id"),
            clinicId: Cookies.get("Clinic_id")
        };
        axios
            .post("doctor/clinicTabPermissionbyId", data)
            .then((response) => {
                setVar_PermissionObject(response.data.data[0]);
                Cookies.set("menupermissions", JSON.stringify(response.data.data[0]), { expires: 1 });
                // localStorage.setItem('menupermissions', JSON.stringify(response.data.data[0]));
                console.log(Var_PermissionObject_Ref.current, "Var_PermissionObject_Ref");
            })
            .catch((error) => {
                // setLoading(false);
                console.log(error);
            });
    }
    const checkThreeStepVerification = (doctor_id,) => {
        getNotifications()
        var data = {
            "doctor_id": doctor_id,
            "clinic_id": Cookies.get("Clinic_id")
        }
        axios
            .post("doctor/verifyThreeStepVerification", data)
            .then((response) => {
                if (response.status == 200) {
                    let findex = response.data.data.findIndex((obj) => obj.id == 0);
                    var filteredData = response.data.data.filter(x => x.id == "A" || x.id == "R");
                    var filteredData1 = response.data.data.filter(x => x.menu == "Go Live");
                    var rejectres = response.data.data.filter((x) => x.menu == "Reject Reason by Salesadmin");
                    setDeclinestatus(rejectres[0]?.id ? rejectres[0].id : '')


                    if (filteredData.length != 0) {
                        setApproved(filteredData[0].id);
                        if (filteredData[0].id == 'A') {
                            setApproved('P');
                            setApprovedLive('A');
                            setVerificationPage(true)
                            setActiveStep(findex)
                            setVar_DoctorId(doctor_id)
                            // setVerificationPage(false)
                            // setActiveStep(0)
                        }
                        else if (filteredData[0].id == 'R') {
                            setApproved('R');
                            setApprovedLive('P');
                            Cookies.set("FooterStatus", "P", { expires: 1 });
                            // localStorage.setItem("FooterStatus", "P");
                            setVerificationPage(true)
                            setActiveStep(findex)
                            console.log(findex, "findex========");
                            return
                        }
                        if (filteredData1[0].id != '0' && filteredData1[0].id != '' && filteredData1[0].id != null) {
                            // setApprovedStatus(filteredData1[0].id);
                            setApproved('A');
                            Cookies.set("FooterStatus", "A", { expires: 1 });
                            // localStorage.setItem("FooterStatus", "A");
                            setVerificationPage(false);
                            setActiveStep(0);
                        } else {
                            setApprovedStatus(filteredData1[0].id);
                        }
                    } else {
                        setApproved('P');
                        setApprovedLive('P');
                            Cookies.set("FooterStatus", "P", { expires: 1 });

                        // localStorage.setItem("FooterStatus", "P");
                        setVerificationPage(true)
                        setActiveStep(findex)
                        // if(findex == 1){
                        //     setActiveStep(findex);
                        // }else if(findex == 2){
                        //     setActiveStep(findex- 1);
                        //     setActiveStep(findex);
                        // }
                        console.log(findex, "findex========");

                    }
                    console.log(approved, "approved=====");
                }
            })
            .catch((error) => {
                // setLoading(false);
                console.log(error);
            });
    }
    // const updategoLiveStatus = () => {
    //     debugger;
    //     var data = {
    //         // "vendor_id": localStorage.getItem("clinic_id") ? localStorage.getItem("clinic_id") : ""
    //         "vendor_id": Var_DoctorId ? Var_DoctorId : ""
    //     }
    //     axios
    //         .post("admin/updateGoLiveStatus", data)
    //         .then((response) => {
    //             debugger;

    //             if (response.data.status == 1) {
    //                 setApproved('A');
    //                 setVerificationPage(false);
    //                 setActiveStep(0);
    //                 // setApprovedStatus(1);
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }
    const getNotifications = () => {
        setLoading(true);
        var data = {
            doctor_id: Cookies.get("Doctor_id"),
            clinic_id: Cookies.get("Clinic_id"),
            speciality_id: Cookies.get("speciality_Id")
        };
        axios
            .post("doctor/doctorwebnotification", data)
            .then((response) => {
                setVar_NotificationData(response.data.data);
                setVarnotificationcount(response.data.data.filter(x => x.to_date == formattedDate && (x.speciality_id == Cookies.get("speciality_Id") && x.doctor_id == Cookies.get("Doctor_id")) || x.to_date == formattedDate && (x.ref_speciality_id == Cookies.get("speciality_Id") && x.ref_doctor_id == Cookies.get("Doctor_id"))))
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const currentDate = new Date();
    // Get the year, month, and day
    const year = currentDate.getFullYear();
    const month = ('0' + (currentDate.getMonth() + 1)).slice(-2); // Adding 1 because January is 0
    const day = ('0' + currentDate.getDate()).slice(-2);
    // Format the date as "YYYY-MM-DD"
    const formattedDate = `${year}-${month}-${day}`;
    const getMenulist = () => {
        // axios({
        //     method: "POST",
        //     url: "admin/getCollateralVideosByVendor",
        //     data: {
        //         "vendorId": 3
        //     },
        // })
        //     .then((response) => {
        //         if (response.data.status == 200) {
        //             setVideoListbyMenu(response.data.data)
        //         }
        //         else {
        //             setVideoListbyMenu([])
        //         }
        //     })
        //     .catch((error) => {
        //         console.log(error);
        //     });
    }
    const handleMenuCardOnClick = (data) => {
        if (videoListbyMenu.length != 0 && data != '') {
            var video = videoListbyMenu.filter((obj) => { return obj.menu_name.toLowerCase() == data.toLowerCase() })
            if (video.length > 0) {
                setMenuVideo(video)
                setisOpenVideoPopup(true)
                setCurrentVideo(video[0].video_path ? video[0].video_path : '')
                setCurrentSubmenuid(video[0].sub_menu_id)
                setVideoPopupTitle(video[0].menu_name)
            }
            else {
                setMenuVideo([])
            }
        }
        else {
            setMenuVideo([])
        }
    }
    const navClick = (data) => {
        setCurrentVideo(data.video_path ? data.video_path : '')
        setCurrentSubmenuid(data.sub_menu_id)
        setVideoPopupTitle(data.menu_name)
    }
    const sendToken = () => {

        var data = {
            "vendor_id": Cookies.get("Doctor_id"),
            "token": Cookies.get("TokenFCM")
        };
        axios
            .post("admin/insertvendorwebtokenclinic", data)
            .then((response) => {
                console.log("update token response", response);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    function rejectIcon() {
        return (
            <div className="rejectimage">
                <img src={RejectIcon} />
            </div>
        );
    }
    const openProfilePopup = () => {
        getCliniProfile();
        setTimeout(() => {
            setProfilePopupOpen(true);
        }, 300)
    }
    const closeProfilePopup = () => {
        setProfilePopupOpen(false);
    }
    async function getCliniProfile() {
        setLoading(true);
        const aesKey = await initEncryptionSession();
        var data = {
            doctorId: Cookies.get("Doctor_id")
        };
        const encrypted = await encryptData(data, aesKey);
        axios
            .post("doctor/getDoctorDetails", {
          objects:encrypted
        })
            .then(async (response) => {
                const decryptedData = await decryptData(
                                                    response.data.data,        // encrypted data only
                                                    aesKey
                                                  );
                                                response.data.data = decryptedData;
                setVar_Profiledata(response.data.data);
                Cookies.set("speciality_Id", response.data.data[0].speciality[0].specialityId,{ expires: 1 });
                setVarSpeciality(response.data.data[0].speciality[0].speciality);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false)
                console.log(error);
            });
    }

    const logoutsuccess = (path) => {
        setVar_ProfileSuccessfully("Logout successful.");
        setVar_IsShowSuccess(true);
        setTimeout(() => {
            setVar_IsShowSuccess(false);
            localDataClear();
            logout(path);
        }, 3000);
    };

    const logout = (path) => {
        Var_History.push(path);
    };

    const localDataClear = () => {
            Cookies.remove("LoginData");
            Cookies.remove("clinic_name");
            Cookies.remove("Clinic_id");
            Cookies.remove("clinic_id");
            Cookies.remove("clinic_vendor_type_id");
            Cookies.remove("Doctor_id");
            Cookies.remove("doctor_id");
            Cookies.remove("speciality_Id");
            Cookies.remove("isChangeClinic");
            Cookies.remove("tokenHeader");
            Cookies.remove("tokenExpiry");
            localStorage.removeItem("LoginData");
            localStorage.removeItem("clinic_name");
            localStorage.removeItem("clinic_id");
            localStorage.removeItem("clinic_vendor_type_id");
            localStorage.removeItem("doctor_id");
            localStorage.removeItem("speciality_Id");
            localStorage.removeItem("isChangeClinic");
    };
    const getClinicDoctor = async () => {
        setLoading(true);
        const aesKey = await initEncryptionSession();
        var data = {
            doctorId: Cookies.get("Doctor_id")
        };
        const encrypted = await encryptData(data, aesKey);
        axios
            .post("doctor/getDoctorClinics", {
          objects:encrypted
        }
        )
            .then(async (response) => {
                const decryptedData = await decryptData(
                    response.data.data,        // encrypted data only
                    aesKey
                  );
                response.data.data = decryptedData;
                let selectedClinic = response.data.data[0];
                if (Cookies.get("isChangeClinic") == 1) {
                    const filterClinic = response.data.data.filter((item) => item.clinicId == Cookies.get("Clinic_id"));
                    if (filterClinic.length > 0) {
                        selectedClinic = filterClinic[0];
                    }
                }
                setVar_DoctorCurrentClinic(selectedClinic);
                if (selectedClinic) {
                    Cookies.set("Clinic_id", selectedClinic.clinicId, { expires: 1 });
                    if (selectedClinic.pharmacyId) {
                        Cookies.set("pharmacy_id", selectedClinic.pharmacyId, { expires: 1 });
                        localStorage.setItem("pharmacy_id", selectedClinic.pharmacyId);
                    }
                }
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
            });
    }
    
    const doctorClinicSelect = (e) => {
        setVar_DoctorCurrentClinic(e.target.value);
        Cookies.set("Clinic_id", e.target.value.clinicId);
        if (e.target.value.pharmacyId) {
            Cookies.set("pharmacy_id", e.target.value.pharmacyId, { expires: 1 });
            localStorage.setItem("pharmacy_id", e.target.value.pharmacyId);
        }
        Cookies.set("isChangeClinic", 1);
        onEdit(Cookies.get("Clinic_id"), 'Data');
    }
    return (
        <div>
            {/* ==================== Header Start=================== */}
            <div className="dashboard_header">
                <div className="dashboard_header_row">
                    <div className="dashboard_header_content">
                        <div className="dashboard_header_column">
                            <img src={Var_Profiledata && Var_Profiledata[0] && Var_Profiledata[0].vendor_profile_path && Var_Profiledata[0].vendor_profile_path.trim() !== "" ? Var_Profiledata[0].vendor_profile_path : (localStorage.getItem("profilePath") || "")} alt="logo" className="dashboard_header_logo" style={{ borderRadius: "50%", objectFit: "cover" }} />
                        </div>
                        <div className='dashboard_header_dropdown'>
                            <div className='dashboard_header_dropdown_button'>
                                {!headerDropdownStatus_Ref.current ? 
                                       <div className='fix_dropdown'>
                                            <div className='drop dropdown_button'>
                                                <FormControl fullWidth>
                                                    <Select size="small" className="selectoption" sx={{ m: 1, minHeight: 1, minWidth: 100 }}
                                                        id="demo-simple-select"
                                                        value={Var_DoctorCurrentClinic_Ref.current}
                                                         readOnly={true}
                                                        onChange={(e) => {
                                                            doctorClinicSelect(e)
                                                        }}  >
                                                        {Var_DoctorClinicSelect_Ref.current.map((item) => (
                                                            <MenuItem
                                                                key={item.clinicName}
                                                                value={item}>
                                                                {item.clinicName}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div> :
                                      <div className='fix_dropdown'>
                                            <div className='drop dropdown_button'>
                                                <FormControl fullWidth>
                                                    <Select size="small" className="selectoption" sx={{ m: 1, minHeight: 1, minWidth: 100 }}
                                                        id="demo-simple-select"
                                                        value={Var_DoctorCurrentClinic_Ref.current}
                                                        onChange={(e) => {
                                                            doctorClinicSelect(e)
                                                        }}  >
                                                        {Var_DoctorClinicSelect_Ref.current.map((item) => (
                                                            <MenuItem
                                                                key={item.clinicName}
                                                                value={item}>
                                                                {item.clinicName}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>}
                            </div>
                        </div>
                    </div>
                    <div style={{ flexGrow: "1" }}>
                    </div>
                    <div className="dashboard_header_profile_part flex items-center gap-3">
                        <div className="dashboard_header_icons">
                            <div className="dashboard_header_home_icon">
                                <img src={homeIcon} alt="log" className="header_home_image"
                                    onClick={() => routeNavigation("/")}
                                />
                            </div>
                        </div>
                        <div
                            className="flex items-center gap-2.5 cursor-pointer hover:opacity-90 transition-opacity my-auto"
                            onClick={() => openProfilePopup()}
                        >
                            <div className="text-right leading-tight">
                                <p className="text-sm font-bold text-gray-900 m-0">
                                    {Var_Profiledata?.[0]?.doctorName || Cookies.get("doctor_Name") || "Doctor"}
                                </p>
                                <p className="text-[12px] text-gray-400 font-medium m-0 mt-0.5">
                                    {Var_DoctorCurrentClinic?.clinicName || Cookies.get("Clinic_name") || Cookies.get("clinic_name") || "Clinic"}
                                </p>
                            </div>
                            <img
                                src={
                                    Var_Profiledata?.[0]?.vendor_profile_path && Var_Profiledata[0].vendor_profile_path.trim() !== ""
                                        ? Var_Profiledata[0].vendor_profile_path
                                        : (localStorage.getItem("profilePath") || "")
                                }
                                alt="Doctor Profile"
                                className="w-9 h-9 rounded-full object-cover border border-teal-500 shadow-2xs"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* ==================== Header End=================== */}

            {/* =======================Profile Popup start=========================================== */}
            <div>
                <Dialog className="profile_model"
                    open={ProfilePopupOpen} onClose={closeProfilePopup}
                    PaperProps={{
                        style: {
                            borderRadius: "24px",
                            padding: "16px",
                            maxWidth: "420px",
                            width: "100%"
                        }
                    }}
                >
                    <DialogContent sx={{ padding: "16px" }}>
                        {Var_Profiledata_ref.current?.map((item, i) => (
                            <div key={i} style={{ textAlign: "center" }} className="space-y-4 font-sans">
                                <div className="profile-image-container mb-3 flex justify-center">
                                    <img
                                        src={item.vendor_profile_path && item.vendor_profile_path.trim() !== "" ? item.vendor_profile_path : (localStorage.getItem("profilePath") || "")}
                                        style={{ width: "120px", height: "120px", borderRadius: "50%", objectFit: "cover", border: "3px solid #2f887c" }}
                                        alt="Doctor Profile"
                                    />
                                </div>
                                <h3 className="text-xl font-bold text-gray-900 m-0">{item.doctorName}</h3>
                                <p className="text-xs text-teal-600 font-bold uppercase tracking-wider mt-1">{VarSpeciality_Ref.current || "Medical Doctor"}</p>

                                <div className="bg-gray-50 rounded-2xl p-4 my-4 border border-gray-100 text-left space-y-2.5">
                                    <div className="flex justify-between items-center text-xs">
                                        <span className="text-gray-400 font-bold uppercase text-[10px] tracking-wider">Age</span>
                                        <span className="text-gray-800 font-semibold">{item.age || "-"} yrs</span>
                                    </div>
                                    <div className="flex justify-between items-center text-xs border-t border-gray-100 pt-2">
                                        <span className="text-gray-400 font-bold uppercase text-[10px] tracking-wider">Specialty</span>
                                        <span className="text-gray-800 font-semibold">{VarSpeciality_Ref.current || "-"}</span>
                                    </div>
                                    <div className="flex justify-between items-start text-xs border-t border-gray-100 pt-2">
                                        <span className="text-gray-400 font-bold uppercase text-[10px] tracking-wider shrink-0 mr-4">Clinic Address</span>
                                        <span className="text-gray-800 font-medium text-right line-clamp-2">{item.clinic_address || item.address || "-"}</span>
                                    </div>
                                </div>

                                <div className="flex items-center justify-center gap-3 pt-2">
                                    <button
                                        type="button"
                                        className="flex-1 h-11 bg-rose-50 text-rose-600 hover:bg-rose-100 rounded-xl font-bold text-xs uppercase tracking-wider flex items-center justify-center gap-2 transition-all cursor-pointer border border-rose-100"
                                        onClick={() => logoutsuccess("/")}
                                    >
                                        <img src={logoutIcon} className="w-4 h-4 opacity-80" alt="Logout" />
                                        <span>Logout</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="flex-1 h-11 bg-[#2f887c] text-white hover:bg-[#256f65] rounded-xl font-bold text-xs uppercase tracking-wider flex items-center justify-center gap-2 transition-all cursor-pointer shadow-md shadow-teal-700/10"
                                        onClick={() => {
                                            closeProfilePopup();
                                            routeNavigation("/profile");
                                        }}
                                    >
                                        <img src={editIcon} className="w-4 h-4 invert" alt="Edit" />
                                        <span>Edit Profile</span>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </DialogContent>
                </Dialog>
            </div>
            {/* =======================Profile Popup end=========================================== */}




            {/* <div className="home_header">
          <Row className="home_header_row">
            <Col sm="12" md="3" lg="3" className="d-flex">
              <Button className="header_back" onClick={() => handleOnClick(" ")}>
              <i className="fa fa-angle-left header_back_button " aria-hidden="true"></i>
              </Button>
              <h5 className="header_name">Wallet</h5>
            </Col>
            <Col sm="12" md="5" lg="5"></Col>
            <Col sm="12" md="2" lg="2">
              <TextField
                className="header_input"
                placeholder="Saud,Density"
                variant="outlined"
              />
            </Col>
            <Col sm="12" md="2" lg="2"></Col>
          </Row>
        </div>
        <div className="credit_point_row_one">
          <div className="credit_point">
            <Card className="credit_point_card_one">
              <p className="credit_point_name">Dr. Saud</p>
              <p className="credit_point_member">Gold Member</p>
              <p className="credit_point_wallet">Wallet Balance - Nil</p>
            </Card>
          </div>
          <div></div>
          <div className="credit_point">
            <Card className="credit_point_card_two">
              <img src={TOMLogo} alt="a" className="credit_point_img" />
            </Card>
          </div>
        </div>
        <div className="credit_point_row_two">
          <div className="credit_point">
            <Card className="credit_point_card_three">
              <img src={Prices} alt="a" className="credit_point_imgs" />
              <p className="credit_point_kwd">
                <span>110</span> <span className="fontSize10">(KWD)</span>
              </p>
              <p className="credit_point_earned">Earned So Far</p>
            </Card>
          </div>
          <div></div>
          <div className="credit_point">
            <Card className="credit_point_card_four">
              <img src={Prices} alt="a" className="credit_point_imgs" />
              <p className="credit_point_kwd">
                <span>10</span> <span className="fontSize10">(KWD)</span>
              </p>
              <p className="credit_point_earned">Earned This Week</p>
            </Card>
          </div>
        </div>
        <div className="credit_point_row_three">
          <Card className="credit_point_card_five">
            <Row>
              <Col sm="12" md="1" lg="1">
                <img src={TOMLogo} alt="a" className="credit_point_images" />
              </Col>
              <Col sm="12" md="5" lg="5">
                <div>
                  <h5 className="credit_point_card_name">
                    Norah's booking of Lina's & Dina's,Diet
                  </h5>
                  <p className="credit_point_date">03-Apr-23</p>
                </div>
              </Col>
              <Col sm="12" md="5" lg="5"></Col>
              <Col sm="12" md="1" lg="1" className="credit_point_mobile">
                <i className="fa fa-mobile" aria-hidden="true"></i>
              </Col>
            </Row>
          </Card>
        </div> */}
        </div>
    );
};
export default HeaderMasterComponent;